module.exports = __webpack_public_path__ + "static/media/logo_yellow.88ff9d4f.png";